import React, { Fragment } from 'react'
import styled, { css } from 'styled-components'
import { HealthAsk } from '../../models/health-ask'
import breakpoints from '../../styles/breakpoints'
import { colors } from '../../styles/theme'
import Ask from './ask'
import AskConnector from './ask-connector.svg'

type StyledAskConnectorProps = { flip: boolean; color: 'light' | 'dark' }

const StyledAskConnector = styled(AskConnector)`
  display: none;
  width: calc(100% - 155px);
  transform: translateX(calc(155px / 2));
  margin: ${props => props.theme.spacing.base300} 0;

  @media (min-width: ${breakpoints.md}) {
    display: block;
  }

  ${({ flip, color }: StyledAskConnectorProps) =>
    color === 'light'
      ? css`
          path.circle {
            stroke: #ffffff;
            stroke-opacity: 0.3;
          }

          path.line {
            fill: #ffffff;
            fill-opacity: 0.3;
          }
        `
      : css`
          path.circle {
            stroke: ${colors.neutral300};
            stroke-opacity: 1;
          }

          path.line {
            fill: ${colors.neutral300};
            fill-opacity: 1;
          }
        `}

  ${({ flip, color }: StyledAskConnectorProps) =>
    flip &&
    css`
      transform: scaleY(-1) translateX(81px);
    `}
`

const StyledAsk = styled(Ask)`
  padding: ${props => props.theme.spacing.base600} 0;

  @media (min-width: ${breakpoints.md}) {
    padding: 0;
  }
`

const AskList = ({ asks, color }: { asks: HealthAsk[]; color: 'light' | 'dark' }) => {
  return (
    <>
      {asks.map((ask, index) => {
        const flipped = index % 2 === 1

        return (
          <Fragment key={index}>
            <StyledAsk ask={ask} justification={flipped ? 'right' : 'left'} />
            {index !== asks.length - 1 && (
              <StyledAskConnector flip={flipped ? 1 : 0} color={color} />
            )}
          </Fragment>
        )
      })}
    </>
  )
}

export default AskList
